<template>
  <div>
    <b-modal
      ref="my-modal"
      size="xl"
      centered
      hide-footer
      hide-header
      title="Select your Campaign"
    >
      <a
        class="btn-close"
        @click="hideModal"
      >
        <img
          :src="require('@/assets/images/close.png')"
          alt=""
        >
      </a>
      <div class="modal-text px-1">
        <h4 class="mb-2">
          Select your campaign
        </h4>
        <data-table
          ref="reportTable"
          :data-table="dataRunningItem"
          :field-table="dataRunningField"
          :status="dataRunningStatus"
          :table-for="tableFor"
          :data-for="dataFor"
          :list="list"
          :mutation-for="mutationFor"
          :filter-search="filterSearch"
          :button-download="buttonDownload"
        >
          <template #cell(campaign_id)="data">
            <!-- <router-link :to="{ name: 'view-campaign', params: { id: data.value }}"> -->
            <b
              class="text-primary"
            >
              {{ data.value }}
            </b>
            <!-- </router-link> -->
          </template>
          <template #cell(action)="data">
            <div class="d-flex">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                size="sm"
                variant="outline-primary"
                class="font-weight-bolder ml-1"
                @click="setCampaign(data.item.campaign_id)"
              >
                Select
              </b-button>
            </div>
          </template>
          <template #cell(click)="data">
            <span class="text-right d-block">{{ formatPrice(data.value) }}</span>
          </template>
          <template #cell(ctr)="data">
            <span class="text-right d-block">{{ formatPrice(data.value) }}%</span>
            <!-- <span class="text-right d-block">{{ data.value }}</span> -->
          </template>
          <template #cell(cvr)="data">
            <span class="text-right d-block">{{ formatPrice(data.value) }}%</span>
          </template>
          <template #cell(mt)="data">
            <span class="text-right d-block">{{ formatPrice(data.value) }}</span>
          </template>
          <template #cell(impression)="data">
            <span class="text-right d-block">{{ formatPrice(data.value) }}</span>
          </template>
          <template #cell(total_usage)="data">
            <span class="text-right d-block">{{ formatPrice(data.value) }}</span>
          </template>
          <template
            v-if="dataRole === 'Telco'"
            #cell(company_name)="data"
          >
            {{ data.value }}
          </template>
        </data-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BButton,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import DataTable from '@/views/component/DataTable.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    BModal,
    BButton,
    DataTable,
  },
  directives: {
    Ripple,
  },
  props: {

  },
  data() {
    return {
      tableFor: 'auction',
      dataFor: 'dataRunningCampaign',
      mutationFor: 'RUNNING',
      disabledBtnFilter: true,
      filterSearch: false,
      buttonDownload: false,
      list: 'getRunningCampaign',
      role: this.$store.state.auth.userData.data.Account.role_id,
      dept: this.$store.state.auth.userData.data.departement.id,
    }
  },
  computed: {
    ...mapGetters('auction', {
      dataRunningField: 'getRunningField',
      dataRunningItem: 'getRunningItem',
      dataRunningStatus: 'getRunningStatus',
      campaignList: 'getCampaignIdList',
    }),
    ...mapGetters('auth', {
      dataRole: 'getRole',
    }),
  },
  mounted() {
    this.getRunningCampaign()
  },
  methods: {
    ...mapActions('auction', [
      'getRunningCampaign',
    ]),
    formatPrice(value) {
      if (!this.isFloat(value)) {
        let val = (value / 1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
      return value
    },
    isFloat(n) {
      return Number(n) === n && n % 1 !== 0
    },
    emptyCampaign() {
      this.$swal({
        title: "You don't have a running campaign yet",
        text: 'Please click continue to create new campaign',
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      }).then(result => {
        if (result.value) {
          // const routeName = this.$route.matched[0].path
          this.$router.push({ path: '/campaign/create' })
        }
      })
    },
    showModal() {
      this.getRunningCampaign().then(() => {
        // console.log(this.dataRunningItem.data, 'data-running')
        if (this.dataRunningItem.data.length !== 0) {
          this.$refs['my-modal'].show()
        } else {
          this.emptyCampaign()
        }
      })
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    setCampaign(id) {
      this.$emit('selectCampaign', id)
      this.hideModal()
    },
  },
}
</script>
<style scoped>
.btn-close {
  position: absolute !important;
  right: 18px;
  top: 14px;
}
.img-success-register {
  margin-top: 43px;
}
.modal-text {
  text-align: center;
  font-family: 'Rubik';
  margin-top: 18px;
  margin-bottom: 40px
}

.modal-text > h4 {
  font-weight: bold;
  color: #000;
  margin-bottom: 0;
}

.modal-text > p {
  margin-top: 15px;
}
</style>
